var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFastStartBonusesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.223,
    height: 43.7,
    viewBox: "0 0 26.223 43.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-rocket",
    "data-name": "Icon ionic-md-rocket",
    transform: "translate(-7.882 -1.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M19.116,29.884a9.8,9.8,0,0,1-3.906-.992.708.708,0,0,0-.992.692l.319,4.643a.356.356,0,0,0,.574.255l1.32-1a.36.36,0,0,1,.519.091l1.866,2.922a.357.357,0,0,0,.6,0l1.866-2.922a.36.36,0,0,1,.519-.091l1.32,1a.356.356,0,0,0,.574-.255l.319-4.643a.7.7,0,0,0-.992-.692A9.846,9.846,0,0,1,19.116,29.884Z",
    transform: "translate(1.867 8.167)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M33.884,26.353l-4.37-4.47c0-14.385-8.485-20.757-8.485-20.757S12.461,7.5,12.461,21.882l-4.37,4.47a.757.757,0,0,0-.2.646L9.566,37.177a.7.7,0,0,0,1.074.492l6.109-4.133a6.95,6.95,0,0,0,4.288,1.821,6.572,6.572,0,0,0,4.2-1.821l6.109,4.133a.7.7,0,0,0,1.074-.492L34.1,26.99A.809.809,0,0,0,33.884,26.353Zm-12.855-9.2a2.916,2.916,0,1,1,2.795-2.913A2.852,2.852,0,0,1,21.028,17.148Z",
    transform: "translate(0)",
    fill: "#3d3d3d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastStartBonusesIcon);
export default __webpack_public_path__ + "static/media/fast-start-bonuses-icon.f6089b32f6faaf01acb41290bee9d49f.svg";
export { ForwardRef as ReactComponent };